import { DoorType } from '../enums/doorType.enum';
import { DoorDirection } from '../enums/doorDirection.enum';
import { HingeType } from '../enums/hingeType.enum';
import { DoorHandleType } from '../enums/doorHandleType.enum';

export class DoorModel {
  panelWidth: number;
  panelHeight: number;

  type: DoorType;
  direction: DoorDirection;
  openingWidth: number;
  openingHeight: number;
  hingeType: HingeType;
  handleType: DoorHandleType;

  constructor(
    type: DoorType,
    openingWidth: number,
    openingHeight: number,
    panelWidth: number,
    panelHeight: number,
    direction?: DoorDirection,
    doorHandleType = DoorHandleType.euro2015,
    hingeType = HingeType.normal
  ) {
    this.openingHeight = openingHeight;
    this.openingWidth = openingWidth;
    this.panelWidth = panelWidth;
    this.panelHeight = panelHeight;
    this.type = type || DoorType.Turn;
    this.direction = direction || DoorDirection.left;
    this.hingeType = hingeType;
    this.handleType = doorHandleType;
  }

  public getPanelHeight(): number {
    return this.panelHeight;
  }

  public setPanelHeight(panelHeight: number): void {
    this.panelHeight = panelHeight;
  }

  public getOpeningWidth(): number {
    return this.openingWidth;
  }

  public getOpeningHeight(): number {
    return this.openingHeight;
  }

  public getType(): DoorType {
    return this.type;
  }

  public getHingeType(): HingeType {
    return this.hingeType;
  }

  public getHandleType(): DoorHandleType {
    return this.handleType;
  }

  public getDoorDirection(): DoorDirection {
    return this.direction;
  }
}
